import { render } from "./App.vue?vue&type=template&id=1586171a"
const script = {}

import exportComponent from "/Users/q/Documents/projects/religious-app/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__